import React from 'react'
import { Switch, Redirect } from 'react-router'
import { Route } from 'react-router-dom'
import { CartPage } from '../pages/Cart/Cart'
import BrowseWrapper from '../wrappers/BrowseWrapper'
import { PurchaseHistoryPage } from '../pages/Account/PurchaseHistory/PurchaseHistory'
import AccountWrapper from '../pages/Account/AccountWrapper'
import WizardWrapper from '../pages/Wizard/WizardWrapper'
import ViewCourseLesson from '../pages/Course/ViewCourseLesson/ViewCourseLesson'
import BeneficiaryWrapper from '../wrappers/BeneficiaryWrapper'
import BusinessWrapper from '../wrappers/BusinessWrapper'
import AuthWrapper from '../wrappers/AuthWrapper'
import Dashboard from '../pages/Homepage/Dashboard'
import UserContentWrapper from '../wrappers/UserContentWrapper'
import AuthenticatedRoute from '../components/Authentication/AuthenticatedRoute'
import WishList from '../pages/WishList/WishList'
import { AppError404 } from '../pages/Errors/404'
import { userSelectors } from '../redux/userSlice'
import { useSelector } from 'react-redux'
import { UserTypes } from '../util/constants'
import CancelSubscription from '../pages/Account/CancelSubscription/CancelSubscription'

function DashboardRedirect() {
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const userType = useSelector(userSelectors.userType)

    if (!isLoggedIn) {
        return <Redirect to="/app/404" />
    }

    if (userType === UserTypes.Beneficiary) {
        return <Redirect to="/app/beneficiary" />
    } else {
        return <Redirect to="/app/dashboard" />
    }
}

const AppRoutes = () => {
    return (
        <>
            <Switch>
                <Route path={'/app/cart'} component={CartPage} />
                <Route path={'/app/browse'} component={BrowseWrapper} />
                <Route path={'/app/wizard'} component={WizardWrapper} />
                <Route path={'/app/auth'} component={AuthWrapper} />
                <Route path={'/app/business'} component={BusinessWrapper} />
                <AuthenticatedRoute
                    path={'/app/dashboard'}
                    component={Dashboard}
                />
                <AuthenticatedRoute
                    path={'/app/wishlist'}
                    component={WishList}
                />
                <AuthenticatedRoute
                    path={'/app/account/cancel-subscription'}
                    component={CancelSubscription}
                />
                <AuthenticatedRoute
                    path={'/app/account/purchase-history'}
                    component={PurchaseHistoryPage}
                />
                <AuthenticatedRoute
                    path={'/app/account'}
                    component={AccountWrapper}
                />
                <AuthenticatedRoute
                    path={
                        '/app/courses/:courseId/:enrollmentId/lessons/:lessonId/:topicId'
                    }
                    component={ViewCourseLesson}
                />
                <Route
                    path={'/app/beneficiary'}
                    component={BeneficiaryWrapper}
                />
                <Route path={'/app/my*'} component={UserContentWrapper} />
                <Route path={'/app'} exact component={DashboardRedirect} />
                <Route path={'/app'} component={AppError404} />
            </Switch>
        </>
    )
}

export default AppRoutes
